import React from 'react';
import {CSSTransition, SwitchTransition} from 'react-transition-group';
import {useLocation} from 'react-router-dom';

export interface TransitionWrapperProps {
    children: JSX.Element;
    transitionKey?: string;
}

function TransitionWrapper({children, transitionKey}: TransitionWrapperProps): JSX.Element {
    const location = useLocation();

    return (
        <SwitchTransition mode="out-in">
            <CSSTransition key={transitionKey || location.pathname} classNames="fade" timeout={300} exit={false}>
                {children}
            </CSSTransition>
        </SwitchTransition>
    );
}

export default TransitionWrapper;
